import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "feedback-management" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "admin-modal admin-modal--wide" }
const _hoisted_4 = { class: "admin-feedback-meta" }
const _hoisted_5 = { class: "admin-feedback-content" }
const _hoisted_6 = {
  key: 0,
  class: "admin-feedback-replies"
}
const _hoisted_7 = { class: "admin-feedback-reply__header" }
const _hoisted_8 = { class: "admin-feedback-reply__content" }
const _hoisted_9 = { class: "admin-feedback-status-row" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "admin-feedback-reply-form" }
const _hoisted_12 = { class: "admin-modal__actions" }
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DataTable, {
      columns: _ctx.columns,
      "data-source": _ctx.sortedFeedbacks,
      loading: _ctx.loading,
      total: _ctx.total,
      current: _ctx.page,
      "page-size": _ctx.pageSize,
      "row-key": "id",
      "empty-text": "暂无反馈",
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.key === 'user')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(record.nickname || record.email || record.username || record.user_id), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'type')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.formatFeedbackType(record.type)), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'status')
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: _normalizeClass(['admin-feedback-status', `admin-feedback-status--${record.status}`])
            }, _toDisplayString(_ctx.formatFeedbackStatus(record.status)), 3))
          : _createCommentVNode("", true),
        (column.key === 'responseTime')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(_ctx.formatResponseTime(record)), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createElementBlock("button", {
              key: 4,
              type: "button",
              onClick: ($event: any) => (_ctx.openFeedbackDetail(record))
            }, "查看", 8, _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "data-source", "loading", "total", "current", "page-size", "onChange"]),
    (_ctx.feedbackDetailVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "admin-modal-overlay",
          onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeFeedbackDetail && _ctx.closeFeedbackDetail(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.selectedFeedback?.title), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(_ctx.selectedFeedback ? _ctx.formatFeedbackType(_ctx.selectedFeedback.type) : ''), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.selectedFeedback ? _ctx.formatFeedbackStatus(_ctx.selectedFeedback.status) : ''), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.selectedFeedback?.nickname || _ctx.selectedFeedback?.email || _ctx.selectedFeedback?.username || _ctx.selectedFeedback?.user_id), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.selectedFeedback?.created_at), 1)
            ]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.selectedFeedback?.content), 1),
            (_ctx.selectedFeedback?.replies && _ctx.selectedFeedback.replies.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[6] || (_cache[6] = _createElementVNode("h4", null, "历史回复", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFeedback.replies, (reply) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: reply.id,
                      class: "admin-feedback-reply"
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("span", {
                          class: _normalizeClass({ 'admin-feedback-reply--admin': reply.is_admin_reply })
                        }, _toDisplayString(reply.is_admin_reply ? '管理员' : (reply.author_id || '用户')), 3),
                        _createElementVNode("span", null, _toDisplayString(reply.created_at), 1)
                      ]),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(reply.content), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _cache[8] || (_cache[8] = _createElementVNode("label", null, "状态：", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedStatus) = $event))
              }, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("option", { value: "pending" }, "待处理", -1),
                _createElementVNode("option", { value: "processing" }, "处理中", -1),
                _createElementVNode("option", { value: "resolved" }, "已解决", -1),
                _createElementVNode("option", { value: "closed" }, "已关闭", -1)
              ]))], 512), [
                [_vModelSelect, _ctx.selectedStatus]
              ]),
              _createElementVNode("button", {
                type: "button",
                disabled: _ctx.statusUpdating,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeFeedbackStatus && _ctx.changeFeedbackStatus(...args)))
              }, _toDisplayString(_ctx.statusUpdating ? '更新中...' : '更新状态'), 9, _hoisted_10)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[9] || (_cache[9] = _createElementVNode("label", null, "回复内容：", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.replyContent) = $event)),
                rows: "4",
                placeholder: "请输入回复内容"
              }, null, 512), [
                [_vModelText, _ctx.replyContent]
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeFeedbackDetail && _ctx.closeFeedbackDetail(...args)))
                }, "关闭"),
                _createElementVNode("button", {
                  type: "button",
                  disabled: _ctx.replySaving,
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submitReply && _ctx.submitReply(...args)))
                }, _toDisplayString(_ctx.replySaving ? '提交中...' : '提交回复'), 9, _hoisted_13)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}